const PlayerObjectSkeleton: React.FC<{ bigHeader?: boolean }> = ({ bigHeader = false }) =>
  bigHeader ? (
    <div id='player' className='flex w-full animate-pulse items-start gap-2 self-stretch p-2 shadow-sm'>
      <div className='bg-neutral-neutral-8 flex h-16 w-16 rounded-xl md:h-24 md:w-24' />
      <div id='player-main' className='flex flex-col flex-wrap items-start gap-2 self-stretch p-2'>
        <div id='player-name' className='flex items-start gap-2'>
          <div id='nome' className='bg-neutral-neutral-8 h-8 w-64 md:w-96' />
        </div>
        <div id='player-details' className='flex flex-col items-baseline gap-x-5 md:flex-row'>
          <div id='details1' className='bg-neutral-neutral-8 flex h-8 w-20 items-baseline gap-2' />
          <div id='details2' className='bg-neutral-neutral-8 flex h-8 w-30 gap-2' />
          <div id='details3' className='bg-neutral-neutral-8 flex h-8 w-20 gap-2' />
        </div>
      </div>
    </div>
  ) : (
    <div className='animate-pulse rounded-md py-2 shadow-sm'>
      <div className='flex items-center gap-2 p-2'>
        <div className='bg-neutral-neutral-8 flex h-8 w-8 items-center rounded-md' />
        <div className='flex gap-1'>
          <div className='bg-neutral-neutral-8 mb-2 h-2.5 w-16 rounded-full' />
          <div className='bg-neutral-neutral-8 mb-2 h-2.5 w-32 rounded-full' />
        </div>
      </div>
      <div className='text-neutral-neutral-9 px-2 text-xs'>
        <div className='bg-neutral-neutral-8 h-2 w-48 rounded-full' />
      </div>
    </div>
  );

export default PlayerObjectSkeleton;
